import antd from "antdv-next/locale/zh_CN";
import global from "./zh-CN/global.js";
import menu from "./zh-CN/menu.js";

const components = {
  antLocale: antd
};

export default {
  message: "-",
  "layouts.usermenu.dialog.title": "信息",
  "layouts.usermenu.dialog.content": "您确定要注销吗？",
  ...components,
  ...global,
  ...menu
};
